export let messages = {
  USER_ID: "userid",
  TOKEN: "token",
  USER_ROLE: "userRole",
  USER_SUB_ROLE: "userSubRole",
  PROJECT_ID: "projectId",
  BATCH_ID: "batchId",
  PROJECT_NAME: "projectName",
  USER_NAME: "userName",
  BATCH_NAME: "batchName",
  AUTH_CREDS: "Provide your Credentials",
  USER_NAME_AUTH: "User Name",
  PASS: "Password",
  SUCCESS: "success",
  ERROR: "error",
  CLEAR: "Clear",
  LAST_LOGIN: "last_login",
  PROCESS: "process",
  LIMIT: "limits",
  BATCHES: "batches",
  VISUALIZATION: "visualization",
  ALL_REPORTS: "reports",
  CHARTS: "charts",
  AUDIT_TRAIL: "audit-trail",
  CREATE_REPORT: "create-report",
  VIEW_REPORT: "view-report",
};
